import userService from "@/endpoints/userService";
import type { RootState } from "@/store/store";
import { dequal } from "dequal";
import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";

const ContractExpiryPopup: React.FC = ({}) => {
  const [timeLeft, setTimeLeft] = useState(30);

  const redirectBackToLogin = useCallback(() => {
    userService.auth.logout();
  }, []);

  const isAdminUser = useSelector(
    (state: RootState) => state.userDetail && state.userDetail.isAdmin,
    (prev, next) => {
      return dequal(prev, next);
    }
  );

  useEffect(() => {
    if (timeLeft === 0) {
      redirectBackToLogin();
    }

    const timer = setTimeout(() => {
      if (timeLeft > 0) {
        setTimeLeft(timeLeft - 1);
      }
    }, 2000);
    return () => clearTimeout(timer);
  }, [timeLeft, redirectBackToLogin]);

  function handleGoToAdmin() {
    window.location.href = window.location.origin + "/legacy/users";
  }
  return (
    <div className="h-lvh flex-col flex justify-center items-center bg-[#f5f7fa]">
      <div className="min-h-[400px] w-[500px] bg-white p-[30px] border border-[#e4e7ec] bg-white">
        <div className="flex justify-center items-center ">
          <img
            className="w-[200px]"
            src="/images/logo/harris_questbrand_complete_logo.png"
            alt="Harris poll"
          />
        </div>
        <div className="my-[23px] border-y text-[#4A4A4A] border-[#e4e7ec] text-center tracking-[0.2px] [word-spacing:1.5px]">
          <div className="mt-[23px] mb-[18px] font-[16px] font-bold text-[23px]">
            Access Denied
          </div>
          <div>
            {/* {userType === "USER" */}
            {isAdminUser
              ? "Your user account has not been mapped to any group. Please reach out to your Harris Client Service Representative to have brands activated for your account"
              : "Your user account is no longer associated with active brands. Please reach out to your Harris Client Service Representative to have brands activated for your account."}
          </div>
          <div className="mb-[23px] mt-[16px]">
            Contact{" "}
            <a
              className="text-[#0000ee] underline"
              href="mailto:hbp@harrispoll.com"
            >
              hbp@harrispoll.com
            </a>{" "}
            for any further support.
          </div>
        </div>
        <div className="tracking-[0.2px] [word-spacing:1.5px]">
          {isAdminUser && (
            <button
              onClick={handleGoToAdmin}
              className="rounded-[2px] cursor-pointer bg-[#0062ff] w-full p-[14px] mb-2 text-semibold text-white transition hover:bg-[#004ecc]"
            >
              Go to Admin
            </button>
          )}
          <button
            onClick={() => {
              userService.auth.logout();
            }}
            className="rounded-[2px] cursor-pointer bg-[#0062ff] w-full p-[14px] text-semibold text-white transition hover:bg-[#004ecc]"
          >
            Back to Log In
          </button>
          <div className="text-base text-[#4A4A4A] text-center mt-[14px]">
            Redirecting in {timeLeft} seconds
          </div>
        </div>
      </div>
      <div className="text-xs text-[#4A4A4A] text-center mt-[14px]">
        <p>
          &#169; Harris Poll QuestBrand is Copyright of The Harris Poll 2024 -
          2025.
          <br />
          All Rights Reserved.
        </p>
      </div>
    </div>
  );
};

export default ContractExpiryPopup;
